import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import parseHtml from "utils/parserUtil";
import { transformComment } from "utils/commentUtil";


const StreamingText = ({ text, onComplete, speed = 4, stream = true }) => {
    const [displayedText, setDisplayedText] = useState(stream ? '' : text);
    
    useEffect(() => {
        if (!stream) {
            setDisplayedText(text);
            return;
        }
        let index = 0;
        const renderTime = 200 //ms
        const iterations = renderTime/speed
        const tokenLength = Math.ceil(text.length / iterations);
        setDisplayedText('');
        const interval = setInterval(() => {
            setDisplayedText(prev => prev + text.slice(index, index + tokenLength));
            index += tokenLength;
            if (index >= text.length) {
                clearInterval(interval);
                if (onComplete) {
                    onComplete();
                }
            }
        }, speed);
        return () => clearInterval(interval);
    }, [text, onComplete, speed, stream]);

    const createMarkup = () => {
        return marked.parse(displayedText);
    };

    return <span >{parseHtml(createMarkup(), { transform: transformComment, trim: true })}</span>;
};

export default StreamingText;